/* DRINK MILK: gift card page — the card tilts toward the pointer, spins and rolls to the chosen amount,
   flips to show the greeting, then flies into the cart. Ported from the prototype (wedding-site/src/giftcard.js).
   Amounts are the product's variants; the greeting goes with the order as line properties. */
(function () {
const page = document.querySelector(".dm-gc");
if (!page) return;
const gsap = window.gsap;
const ScrollTrigger = window.ScrollTrigger;
gsap.registerPlugin(ScrollTrigger);

const $ = (sel, root = document) => root.querySelector(sel);
const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];
const reducedMotion = () => matchMedia("(prefers-reduced-motion: reduce)").matches;
const money = (n) => n.toLocaleString("en-US");

const form = $(".gc-form");
const card = $(".gc-card");
const amountEl = $(".gc-amount");
const amounts = [...page.querySelectorAll(".gc-amounts input")].map((i) => ({ id: +i.value, amount: +i.dataset.amount }));
let amount = amounts.find((a) => a.id === +page.querySelector(".gc-amounts input:checked")?.value) || amounts[0];
let flipped = false;

/* ---------- Amount picker ---------- */

// The amount buttons come from the product's variants (Liquid)

/* ---------- The card: flip, spin, roll the number ---------- */

function flip(toBack) {
  if (toBack === flipped) return;
  flipped = toBack;
  if (reducedMotion()) return gsap.set(card, { rotationY: flipped ? 180 : 0 });
  gsap.to(card, { rotationY: flipped ? 180 : 0, duration: 0.9, ease: "back.out(1.4)" });
}

function setAmount(next) {
  const from = amount.amount;
  amount = next;
  $(".gc-buy__sum").textContent = `$${money(next.amount)}`;
  if (reducedMotion()) return (amountEl.textContent = money(next.amount));
  // Back to the front, one full spin, and the number rolls up (or down) to the new amount
  flipped = false;
  const counter = { n: from };
  gsap.timeline()
    .to(card, { rotationY: 360, duration: 1, ease: "power3.inOut" })
    .set(card, { rotationY: 0 })
    .to(counter, {
      n: next.amount,
      duration: 0.9,
      ease: "power2.out",
      onUpdate: () => { amountEl.textContent = money(Math.round(counter.n / 10) * 10); },
    }, 0.15);
}

form.addEventListener("change", (e) => {
  if (e.target.name !== "amount") return;
  setAmount(amounts.find((a) => a.id === +e.target.value));
});

// Greeting: written straight onto the back of the card
const placeholders = { to: $(".gc-to").textContent, msg: $(".gc-back__msg").textContent, from: $(".gc-from").textContent };
function paintBack() {
  $(".gc-to").textContent = form.to.value.trim() || placeholders.to;
  $(".gc-from").textContent = form.from.value.trim() || placeholders.from;
  $(".gc-back__msg").textContent = form.msg.value.trim() || placeholders.msg;
  $(".gc-counter").textContent = `${form.msg.value.length}/120`;
}
for (const name of ["to", "from", "msg"]) {
  form[name].addEventListener("focus", () => flip(true));
  form[name].addEventListener("input", paintBack);
}
$(".gc-flip").addEventListener("click", () => flip(!flipped));

/* ---------- Add to cart ---------- */

form.addEventListener("submit", (e) => {
  e.preventDefault();
  const to = form.to.value.trim();
  // The greeting travels with the order, so it shows on it
  const properties = {};
  if (to) properties["To"] = to;
  if (form.from.value.trim()) properties["From"] = form.from.value.trim();
  if (form.msg.value.trim()) properties["Message"] = form.msg.value.trim();
  const fly = () => window.DMCart?.add(amount.id, { properties, from: $(".gc-front") });
  // The front has to face the visitor before it flies into the cart
  if (flipped && !reducedMotion()) {
    flipped = false;
    gsap.to(card, { rotationY: 0, duration: 0.5, ease: "power2.inOut", onComplete: fly });
  } else {
    flip(false);
    fly();
  }
});

/* ---------- Shared shell ---------- */

let lenis = null;
const shell = window.DMShell;

/* ---------- Motion ---------- */

const mm = gsap.matchMedia();
mm.add({ motion: "(prefers-reduced-motion: no-preference)", fine: "(pointer: fine)" }, (ctx) => {
  const { motion, fine } = ctx.conditions;
  if (!motion) return;

  lenis = new window.Lenis({ autoRaf: false });
  lenis.on("scroll", ScrollTrigger.update);
  shell?.setLenis(lenis);
  const raf = (t) => lenis.raf(t * 1000);
  gsap.ticker.add(raf);
  gsap.ticker.lagSmoothing(0);

  // Entrance: the card drops in spinning, then the panel follows
  gsap.timeline({ defaults: { ease: "power4.out" } })
    .from(".gc-tilt", { y: -120, rotationZ: -18, rotationX: 50, opacity: 0, duration: 1.4, ease: "back.out(1.3)" }, 0.1)
    .from(card, { rotationY: -540, duration: 1.8, ease: "power3.out" }, 0.1)
    .from(".gc-title", { y: 60, opacity: 0, duration: 1 }, 0.3)
    .from([".gc-lead", ".gc-step", ".gc-buy", ".gc-note"], { y: 24, opacity: 0, duration: 0.8, stagger: 0.08 }, 0.5)
    .from(".gc-flip", { opacity: 0, duration: 0.6 }, 1.2);

  // Idle: the card floats and the light sweeps across it now and then
  gsap.to(".gc-float", { y: -14, rotationZ: 1.5, duration: 3, ease: "sine.inOut", yoyo: true, repeat: -1 });
  gsap.fromTo(".gc-shine", { "--sweep": "-60%" }, { "--sweep": "160%", duration: 1.6, ease: "power2.inOut", repeat: -1, repeatDelay: 2.6, delay: 2 });

  // Tilt toward the pointer; the glare follows it
  const stage = $(".gc-stage");
  const tiltX = gsap.quickTo(".gc-tilt", "rotationX", { duration: 0.6, ease: "power3.out" });
  const tiltY = gsap.quickTo(".gc-tilt", "rotationY", { duration: 0.6, ease: "power3.out" });
  const move = (e) => {
    const r = stage.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width - 0.5;
    const y = (e.clientY - r.top) / r.height - 0.5;
    tiltY(x * 26);
    tiltX(-y * 20);
    card.style.setProperty("--mx", `${(x + 0.5) * 100}%`);
    card.style.setProperty("--my", `${(y + 0.5) * 100}%`);
  };
  const leave = () => { tiltX(0); tiltY(0); };
  if (fine) {
    stage.addEventListener("pointermove", move);
    stage.addEventListener("pointerleave", leave);
  } else {
    // Touch screens: a slow sway stands in for the pointer
    gsap.to(".gc-tilt", { rotationY: 12, rotationX: -6, duration: 4, ease: "sine.inOut", yoyo: true, repeat: -1 });
  }

  // How it works: steps rise in one after another
  gsap.from(".gc-how__list li", { y: 60, opacity: 0, duration: 0.9, stagger: 0.15, ease: "power3.out", scrollTrigger: { trigger: ".gc-how", start: "top 70%" } });
  gsap.from(".gc-how__n", { scale: 0.4, opacity: 0, duration: 0.8, stagger: 0.15, ease: "back.out(2)", scrollTrigger: { trigger: ".gc-how", start: "top 70%" } });

  // Collection band drifts on its own and with the scroll
  const band = gsap.fromTo(".gc-pick__track", { xPercent: -50 }, { xPercent: 0, duration: 50, ease: "none", repeat: -1 });
  ScrollTrigger.create({
    trigger: ".gc-pick",
    onUpdate: (self) => gsap.to(band, { timeScale: 1 + Math.min(Math.abs(self.getVelocity()) / 120, 8), duration: 0.2, overwrite: true, onComplete: () => gsap.to(band, { timeScale: 1, duration: 0.8 }) }),
  });

  return () => {
    stage.removeEventListener("pointermove", move);
    stage.removeEventListener("pointerleave", leave);
    gsap.ticker.remove(raf);
    lenis.destroy();
    lenis = null;
    shell?.setLenis(null);
  };
});

addEventListener("load", () => ScrollTrigger.refresh());
})();
